<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-[200] flex items-start justify-center px-4 py-8 overflow-y-auto bg-black/50 backdrop-blur-sm"
    @click.self="closeModal"
  >
    <div class="bg-white rounded-xl shadow-2xl w-full max-w-[20rem] aspect-square flex flex-col transform transition-all animate-in fade-in zoom-in duration-300 text-left relative overflow-hidden">
      <div class="px-6 py-4 bg-[#0d4169] text-white flex items-center justify-between rounded-t-xl shrink-0">
        <h2 class="text-base font-bold m-0">{{ editCategory ? 'Edit Category' : 'Add New Category' }}</h2>
        <button @click="closeModal" class="p-1 hover:bg-white/10 rounded-full transition-colors text-white">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
        </button>
      </div>

      <form @submit.prevent="handleSubmit" class="p-6 flex-1 flex flex-col">
        <div class="grid grid-cols-1 gap-y-4">
          <div class="flex flex-col gap-1.5">
            <label class="text-[0.85rem] font-semibold text-[#1e293b]">Category Name</label>
            <input
              v-model.trim="form.name"
              type="text"
              placeholder="Enter category name"
              class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm"
              required
            />
          </div>

          <div class="flex flex-col gap-1.5">
            <label class="text-[0.85rem] font-semibold text-[#1e293b]">Remark</label>
            <textarea
              v-model.trim="form.remark"
              rows="2"
              placeholder="Optional remark"
              class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm resize-none"
            ></textarea>
          </div>
        </div>

        <div class="mt-auto pt-5 border-t border-slate-100 flex items-center justify-end gap-3">
          <button type="button" @click="closeModal" class="px-5 py-2 text-sm font-semibold text-slate-500 hover:text-slate-800 transition-colors">
            Cancel
          </button>
          <button
            type="submit"
            :disabled="saving"
            class="min-w-[100px] px-8 py-2 bg-[#0d4169] text-white text-sm font-bold rounded-md shadow-md hover:bg-[#0a3354] transition-all active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed flex justify-center items-center gap-2"
          >
            <div
              v-if="saving"
              class="h-5 w-5 border-2 border-white/30 border-t-transparent rounded-full animate-spin"
            ></div>
            <span v-if="!saving">{{ editCategory ? 'Update' : 'Save' }}</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineExpose, defineProps, reactive, ref, watch } from 'vue'

const props = defineProps({
  isOpen: Boolean,
  editCategory: { type: Object, default: null },
})

const emit = defineEmits(['close', 'save', 'update'])

const saving = ref(false)

const getInitialForm = () => ({
  id: null,
  name: '',
  remark: '',
})

const form = reactive(getInitialForm())

watch(
  () => props.editCategory,
  (val) => {
    if (val) {
      Object.assign(form, {
        id: val.id,
        name: val.name || '',
        remark: val.remark || '',
      })
    } else {
      Object.assign(form, getInitialForm())
    }
  },
  { immediate: true }
)

watch(
  () => props.isOpen,
  (val) => {
    if (!val) saving.value = false
  }
)

function closeModal() {
  Object.assign(form, getInitialForm())
  saving.value = false
  emit('close')
}

function setError(msg) {
  alert(msg || 'Operation failed')
  saving.value = false
}

async function handleSubmit() {
  if (saving.value) return

  const payload = {
    id: form.id,
    name: form.name,
    remark: form.remark,
  }

  saving.value = true
  if (props.editCategory) {
    emit('update', payload)
  } else {
    emit('save', payload)
  }
}

defineExpose({ setError })
</script>

<style scoped>
.animate-in {
  animation: 0.2s ease-out forwards;
}
.fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}
.zoom-in {
  from { transform: scale(0.97); }
  to { transform: scale(1); }
}
</style>

